const ie11Modal = document.querySelector('.ie11-modal__wrapper');

if (ie11Modal) {
  const closeIe11Modal = ie11Modal.querySelector('.close-ie11-modal');
  closeIe11Modal.addEventListener('click', () => {
    ie11Modal.classList.add('is-hidden');
  });
}
